var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('ListPanel',{attrs:{"portal":_vm.portal,"file-categories":_vm.fileCategories}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }